import React from "react";
import { Stack } from "@mui/material";

type StickyScrollProps = {
  childComponents: React.ReactNode;
  count: number;
};

export const StickyScroll: React.FC<StickyScrollProps> = (props) => {
  const { childComponents, count } = props;

  return (
    <Stack
      width={1}
      height={`calc(${count} * 100vh)`}
      direction="column"
      alignItems="flex-start"
      justifyContent="flex-start"
      spacing={4}
      useFlexGap
    >
      {childComponents}
    </Stack>
  );
};
